import { useEffect } from "react";
import ServicesSection from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import CTA from "@/components/sections/CTA";
import { motion } from "framer-motion";

export default function Services() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="page-services" className="pt-32 bg-[#FAFAF9]">
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex items-center gap-3 text-[#A5854C] mb-8">
          <div className="hairline w-12"></div>
          <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Services</span>
        </div>
        <motion.h1
          initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}
          className="font-serif font-light tracking-[-0.03em] text-[#0E1B2E] text-[48px] md:text-[80px] lg:text-[104px] leading-[0.98] max-w-5xl"
        >
          A complete advisory<br/> <span className="italic text-[#A5854C]">and transaction</span> toolkit.
        </motion.h1>
      </section>
      <ServicesSection />
      <Process />
      <CTA />
    </main>
  );
}
